<template>
  <section
    class="edit-container"
    :class="{'from-quote': fromQuote}">
    <section v-show="!showReply">
      <section
        class="flex-sb-center">
        <h2>{{ title }}</h2>
        <div class="flex">
          <v-button
            class="discard"
            @click="$emit('cancel')">Discard</v-button>
          <v-button
            v-if="editType === 0"
            type="primary"
            @click="handlerSave">Save</v-button>
          <v-button
            v-else
            type="primary"
            @click="handlerNext">Next</v-button>
        </div>
      </section>
      <section class="flex">
        <section
          :class="{
            'width-remark-content':ticket_id,
            'width-reminder-content':isRenewalTicket,
          }">
          <div class="form-container">
            <quick-quote
              v-if="false"
              ref="quickQuote"
              :form="formData"></quick-quote>
            <h1
              v-if="false"
              class="title-quick">KYC</h1>
            <housemaid-policy-form
              v-if="productId == 12"
              ref="housemaid-policy-form"
              :form="formData"
              :isRequired="requireValid"
              :edit-type="editType"
              :showBuyable="showBuyable"
              :checkRefer="checkRefer"
              :isRefer="true"
              @getFormData="getHousemaidFormData" />
            <edit-working-policy-form
              v-else-if="productId == 13"
              ref="working-policy-form"
              :form="formData"
              :edit-type="editType"
              :checkRefer="checkRefer"
              :file-list="fileList"
              :showBuyable="showBuyable"
              :isRequired="requireValid"
              :isRefer="true"
              @getFormData="getHousemaidFormData" />
            <edit-decoration-policy-form
              v-else-if="productId == 15"
              ref="decoration-policy-form"
              :form="formData"
              :edit-type="editType"
              :file-list="fileList"
              :checkRefer="checkRefer"
              :showBuyable="showBuyable"
              :isRequired="requireValid"
              :isRefer="true"
              @getFormData="getHousemaidFormData" />
            <edit-travel-policy-form
              v-else-if="productId == 14"
              ref="travel-policy-form"
              :form="formData"
              :edit-type="editType"
              :file-list="fileList"
              :checkRefer="checkRefer"
              :showBuyable="showBuyable"
              :isRequired="requireValid"
              :isRefer="true"
              @getFormData="getHousemaidFormData" />
            <edit-student-policy-form
              v-else-if="productId == 16"
              ref="student-policy-form"
              :form="formData"
              :edit-type="editType"
              :checkRefer="checkRefer"
              :showBuyable="showBuyable"
              :file-list="fileList"
              :isRefer="true"
              :isRequired="requireValid"
              @getFormData="getHousemaidFormData" />
            <edit-homefire-policy-form
              v-else-if="productId == 17"
              ref="homefire-policy-form"
              :form="formData"
              :edit-type="editType"
              :checkRefer="checkRefer"
              :file-list="fileList"
              :showBuyable="showBuyable"
              :is-reminder="isRenewalTicket"
              :isRefer="true"
              :isRequired="requireValid"
              @getFormData="getHousemaidFormData" />
            <edit-personal-policy-form
              v-else-if="productId == 18"
              ref="personal-policy-form"
              :form="formData"
              :edit-type="editType"
              :checkRefer="checkRefer"
              :file-list="fileList"
              :showBuyable="showBuyable"
              :isRefer="true"
              :isRequired="requireValid"
              @getFormData="getHousemaidFormData" />
            <edit-fire-policy-form
              v-else-if="productId == 20"
              ref="fire-policy-form"
              :form="formData"
              :edit-type="editType"
              :checkRefer="checkRefer"
              :file-list="fileList"
              :showBuyable="showBuyable"
              :isRequired="requireValid"
              :isRefer="true"
              @getFormData="getHousemaidFormData" />
            <edit-drone-policy-form
              v-else-if="productId == 21"
              ref="drone-policy-form"
              :form="formData"
              :edit-type="editType"
              :checkRefer="checkRefer"
              :showBuyable="showBuyable"
              :isRequired="requireValid"
              :isRefer="true"
              @getFormData="getHousemaidFormData" />
            <edit-pet-policy-form
              v-else-if="productId == 22"
              ref="pet-policy-form"
              :form="formData"
              :edit-type="editType"
              :file-list="fileList"
              :checkRefer="checkRefer"
              :showBuyable="showBuyable"
              :isRequired="requireValid"
              :isRefer="true"
              @getFormData="getHousemaidFormData" />
            <template v-else-if="isSME">
              <!--              <edit-sme-kyc-->
              <!--                ref="sme-form"-->
              <!--                :form="formData"-->
              <!--                :is-renew-add="!fromEdit"-->
              <!--                :is-car="isCAR"-->
              <!--                :is-renew-quote="isRenewalTicket||editType==3"-->
              <!--                is-quote-->
              <!--                :is-fina="isFina"-->
              <!--                @refresh="$emit('cancel')"-->
              <!--              ></edit-sme-kyc>-->
              <sme-kyc-form
                ref="sme-form"
                :form="formData"
                :is-quote="true"
                :file-list="fileList"
                is-refer
                :is-fina="isFina"
                @getFormData="getSMEFormData"></sme-kyc-form>
            </template>
            <!--            <sme-form-->
            <!--              v-else-if="productId == 80"-->
            <!--              ref="sme-form"-->
            <!--              :form="referData"-->
            <!--              :showBuyable="showBuyable"-->
            <!--              @getFormData="getSMEFormData"></sme-form>-->
            <template v-else>
              <lazy-dom>
                <el-form
                  ref="form"
                  :model="formData"
                  :rules="rules">
                  <!--                  <div class="form-half">-->
                  <!--                    <div class="form-item">-->
                  <!--                      <span>Expected Effective Date</span>-->
                  <!--                      <el-form-item-->
                  <!--                        ref="pcy_cmnt_dt"-->
                  <!--                        prop="pcy_cmnt_dt">-->
                  <!--                        <v-date-picker-->
                  <!--                          v-model="formData.pcy_cmnt_dt"-->
                  <!--                          :disabled="showBuyable" />-->
                  <!--                      </el-form-item>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div class="flex flex-align-center">
                    <div class="form-half form-item">
                      <span>Expected Effective Date</span>
                      <el-form-item :prop="formData.is_eff_dt_delay?'':'pcy_cmnt_dt'">
                        <v-date-picker
                          v-model="formData.pcy_cmnt_dt"
                          :disabled="showBuyable"/>
                      </el-form-item>
                    </div>
                    <span class="mg-l-15 mg-r-15 color-dark fs-14">Or</span>
                    <v-checkbox
                      v-model="formData.is_eff_dt_delay"
                      :is-boolean="false"
                      :disabled="showBuyable"
                      button-type>As Soon As Possible</v-checkbox>
                  </div>
                  <div
                    v-if="formData.class_id == 14"
                    class="form-item form-half">
                    <span>Coverage</span>
                    <v-radio-group
                      v-model="formData.trm_of_cvr"
                      disabled
                      :button="true"
                      :list="allCoverTypeOptions" />
                  </div>
                  <template v-if="![14,13].includes(formData.class_id)">
                    <div class="flex-sb">
                      <div
                        class="form-half">
                        <div
                          v-if="!isHzmb"
                          class="form-item">
                          <span>Insurance Type</span>
                          <el-form-item
                            ref="trm_of_cvr"
                            prop="trm_of_cvr">
                            <v-select
                              v-model="formData.trm_of_cvr"
                              :list="coverTypeOptions"
                              :disabled="showBuyable"
                              @change="changeInsurance" />
                          </el-form-item>
                        </div>
                        <div
                          v-if="formData.trm_of_cvr != 1||isHzmb"
                          class="form-item">
                          <span>Hire Purchase Owner</span>
                          <el-form-item
                            ref="hp_ind"
                            prop="hp_ind">
                            <v-radio-group
                              v-model="formData.hp_ind"
                              :border="true"
                              :disabled="showBuyable"
                              :list="yesNoOptions" />
                          </el-form-item>
                        </div>
                      </div>
                      <div class="form-half">
                        <div
                          v-if="formData.trm_of_cvr != 1&&!isHzmb"
                          class="form-item">
                          <span>Sum Insured</span>
                          <el-form-item
                            ref="isrd_vl"
                            prop="isrd_vl">
                            <v-input
                              v-model="formData.isrd_vl"
                              type="number"
                              :min="0"
                              :int="true"
                              :keyNumber="true"
                              append="HK$" />
                          </el-form-item>
                        </div>
                        <div
                          v-if="(formData.trm_of_cvr != 1||isHzmb) && formData.hp_ind == 1"
                          class="form-item">
                          <span>Name of Hire Purchase Owner (If Yes for Hire purchase)</span>
                          <el-form-item
                            ref="mortgagor"
                            prop="mortgagor">
                            <v-select
                              v-model="formData.mortgagor"
                              :disabled="showBuyable"
                              :list="mortgagorOption" />
                          </el-form-item>
                          <el-form-item
                            v-if="isMortgagorOther"
                            ref="mortgagor_other"
                            class="margin-top-ten"
                            prop="mortgagor_other">
                            <v-input
                              v-model="formData.mortgagor_other"
                              :disabled="showBuyable"
                            />
                          </el-form-item>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!--              <div-->
                  <!--                v-if="benefitList.length>0"-->
                  <!--                class="info-box extra_checkbox">-->
                  <!--                &lt;!&ndash;          <h2>Insured Items</h2>&ndash;&gt;-->
                  <!--                <div-->
                  <!--                  class="form-item form-half">-->
                  <!--                  <span>Optional Benefits</span>-->
                  <!--                  <el-form-item-->
                  <!--                  >-->
                  <!--                    <v-checkbox-group-->
                  <!--                      v-model="formData.benefits"-->
                  <!--                      :list="benefitList"-->
                  <!--                    />-->
                  <!--                  </el-form-item>-->
                  <!--                </div>-->
                  <!--              </div>-->
                  <template v-if="!isMotorTrade">
                    <div class="flex flex-sb ">
                      <div
                        v-if="insuredItems.length>0"
                        class="form-item option_checkout extra_checkbox">
                        <p class="flex flex-align-center mg-b-8">
                          <span class="fs-16 color-dark fw-600 mg-r-8">Insured Items</span>
                          <v-checkbox
                            v-model="is_insured"
                            @change="handleBenefits"></v-checkbox>
                        </p>
                        <template v-if="is_insured">
                          <v-checkbox-group
                            v-model="formData.benefits"
                            :disabled="showBuyable"
                            :notShowList="notShowList"
                            hasGroup
                            :list="insuredItems" />
                        </template>
                      </div>
                      <div
                        v-if="formData.class_id == 11 && extrabenefitsList.length>0"
                        class="form-item form-half extra_checkbox">
                        <p class="flex flex-align-center mg-b-8">
                          <span class="fs-16 color-dark fw-600 mg-r-8">Extra Benefits</span>
                          <v-checkbox
                            v-model="is_extra"
                            @change="handleExtraBenefits"></v-checkbox>
                        </p>
                        <template v-if="is_extra">
                          <v-checkbox-group
                            v-model="formData.extra_benefits"
                            :list="extrabenefitsList"
                            :disabled="showBuyable"
                          />
                        </template>
                      </div>
                    </div>
                    <template v-if="isHzmb">
                      <h3>Optional Benefits (at least one)</h3>
                      <div class="mg-b-20">
                        <el-form-item
                          ref="limit_type"
                          :rules="rules.checkSelectType"
                          :show-message="false"
                          prop="limit_type">
                          <v-checkbox
                            v-model="formData.limit_type"
                          >機動車第三者責任險</v-checkbox>
                        </el-form-item>
                        <div
                          v-if="formData.limit_type==1"
                          class=" mg-t-15 mg-l-25">
                          <div
                            class="form-item">
                            <span>Third Party Liability Insurance</span>
                            <el-form-item
                              ref="tppd_limit_amt"
                              :rules="rules.select"
                              prop="tppd_limit_amt">
                              <v-select
                                v-model="formData.tppd_limit_amt"
                                :list="allOptions15.tppd_opt"
                              />
                            </el-form-item>
                          </div>
                          <div
                            v-if="formData.tppd_limit_amt"
                            class="form-item">
                            <span>附加醫保外醫療費用責任險{{limit_label.name}}</span>
                            <el-form-item>
                              <v-radio-group
                                v-model="formData.is_nmc_tppd_limit_amt"
                                border
                                :list="allOptions15.need_opt"
                              />
                            </el-form-item>
                          </div>
                        </div>
                      </div>
                      <div class="mg-t-15 mg-b-16">
                        <el-form-item
                          ref="plil_limit_type"
                          :rules="rules.checkSelectType"
                          :show-message="!limitVaild"
                          prop="plil_limit_type">
                          <v-checkbox
                            v-model="formData.plil_limit_type"
                            :is-boolean="false"
                          >機動車第三者附加醫保外醫療費用責任險</v-checkbox>
                        </el-form-item>
                        <div
                          v-if="formData.plil_limit_type==1"
                          class="mg-t-15 mg-l-25">
                          <div
                            class="form-item">
                            <span>Vehicle Occupant Liability Insurance</span>
                            <el-form-item>
                              <v-select
                                v-model="formData.plil_limit_amt"
                                :list="allOptions15.plil_opt"/>
                            </el-form-item>
                          </div>
                          <div
                            v-if="formData.plil_limit_amt"
                            class="form-item">
                            <span>附加醫保外醫療費用責任險{{plill_limit_label.name}}</span>
                            <el-form-item>
                              <v-radio-group
                                v-model="formData.is_nmc_plil_limit_amt"
                                border
                                :list="allOptions15.need_opt"/>
                            </el-form-item>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                  <template v-if="isMotorTrade">
                    <div class="form-item">
                      <span>Type of insurance</span>
                      <el-form-item
                        :rules="rules.select"
                        prop="type_of_ins">
                        <v-radio-group
                          v-model="formData.type_of_ins"
                          :button="true"
                          disabled
                          :list="allOptions13.type_of_ins" />
                      </el-form-item>
                    </div>
                    <div
                      v-if="formData.type_of_ins == 2"
                      class="form-item">
                      <span>Number of Named Driver(s)</span>
                      <el-form-item
                        :rules="rules.no_of_nm_drvr"
                        prop="no_of_nm_drvr">
                        <v-radio-group
                          v-model="formData.no_of_nm_drvr"
                          :button="true"
                          disabled
                          :list="numberFourOptions"
                        />
                      </el-form-item>
                    </div>
                    <div class="form-item">
                      <span>No Claims in the past 3 years?</span>
                      <el-form-item
                        :rules="rules.select"
                        prop="no_claim_3_year">
                        <v-radio-group
                          v-model="formData.no_claim_3_year"
                          :border="true"
                          :list="yesNoOptions"
                        />
                      </el-form-item>
                    </div>
                  </template>
                  <div class="info-box">
                    <h2>Policyholder Details</h2>
                    <template v-if="formData.class_id !== 14">
                      <span
                        v-if="formData.cust_typ === 1"
                        class="mg-b-10 label"
                      >The policyholder should be the owner of the insured vehicle.</span>
                      <span
                        v-else
                        class="mg-b-10 label">
                        The policyholder should be the owner of the insured vehicle.
                        <br />The information is filled according to the customer’s latest record.
                      </span>
                    </template>

                    <policy-holder
                      ref="policy-holder"
                      :isRequired="requireValid"
                      :formDataLock="formDataLock"
                      :form="formData"
                      :usage-ind="formData.usage_ind"
                      :disabled="showBuyable"
                      :is-t-plate="isTPlate"
                      @one-driver="(status) => policyOneDriver = status"
                      @change-driver="handlerPolicyDriverInfo"
                      @getFormData="getSubFormData"
                      @confirm="handlerConfirmChangeInfo" />
                  </div>
                  <template v-if="!isMotorTrade">
                    <div class="info-box">
                      <!--                <h2>Insured Vehicle</h2>-->
                      <insured-vehicle-form
                        ref="insured-vehicle-form"
                        :formDataLock="formDataLock"
                        :form="formData"
                        :isRequired="requireValid"
                        :editType="editType"
                        :disabled="showBuyable"
                        :usageInd.sync="formData.usage_ind"
                        :renewOrderId="renewOrderId"
                        @get-data="getFieldData"
                        @getFormData="getSubFormData"
                        @handleModel="handleModel"
                        @handleInd="handleInd"
                        @getTon='getTon'
                        @already-owned='handleAlreadyOwned'
                      />
                    </div>
                  </template>

                  <template v-if="isMotorTrade&&!isTPlate||!isMotorTrade">
                    <div class="info-box">
                      <h2>Named Driver Information</h2>
                      <drivers-base-info-form
                        ref="drivers-base-info-form"
                        :formDataLock="formDataLock"
                        :form="formData"
                        :orderId="orderId"
                        :usage-ind="formData.usage_ind"
                        :disabled="showBuyable"
                        :isRequired="requireValid"
                        :policyOneDriver="policyOneDriver"
                        @getFormData="getSubFormData"
                        @upload-file="uploadDriversFile"
                        @change-policy-file="handlerDriverPolicyFile"
                        @open-driver="handlerOpenDriver"
                      />
                    </div>
                  </template>
                  <div class="info-box">
                    <h2>Documents</h2>
                    <document-form
                      ref="document-form"
                      :formDataLock="formDataLock"
                      :form="formData"
                      :disabled="showBuyable"
                      :editTypes="editType"
                      :file-list="fileList"
                      :is-reminder="isRenewalTicket"
                      :currentDriversData="currentDriversData"
                      @upload-file="handlerUploadCardFile"
                      @delete-card-file="handlerDeleteCardFile"
                    />
                  </div>
                </el-form>
              </lazy-dom>
            </template>

            <lazy-dom notLoading>
              <use-personal-data
                ref="use-personal-data"
                :marketing_data="marketing_data"
                :company_name="formData.company_language"
                @sendData="getData"></use-personal-data>
            </lazy-dom>
          </div>
        </section>
        <template v-if="!!ticket_id&&!isRenewalTicket">
          <ticket-remark
            ref="ticket-remark"
            :ticket-id="ticket_id"></ticket-remark>
        </template>
        <template v-if="isRenewalTicket">
          <section class="right-col">
            <reminder-detail :form="relation"></reminder-detail>
          </section>
        </template>
      </section>
    </section>
    <section v-if="showReply">
      <reply-refer
        ref="reply"
        :form="formData"
        :fromEdit="fromEdit"
        :editType="editType"
        :customerId = 'customerId'
        :showBuyable="showBuyable"
        :renewOrderId="renewOrderId"
        :hasEndorsNum="hasEndorsNum"
        :hasClaimNum="hasClaimNum"
        :is-draft="checkRefer==1"
        :is-renewal-ticket="isRenewalTicket"
        :is-fina="isFina"
        @update="handleUpdate"
        @nextStep="nextStep"
        @cancelReply="handleCancelReply"
        @save-draft="saveDraft"
        @reply-all="replyAll"
        @complete="replyComplete"
        @cancel="handleBackStep" />
      <!--      <reply-new-sme-refer-->
      <!--        v-else-->
      <!--        :form="formData"-->
      <!--        :editType="editType"-->
      <!--        :customerId = 'customerId'-->
      <!--        :showBuyable="showBuyable"-->
      <!--        :renewOrderId="renewOrderId"-->
      <!--        :hasEndorsNum="hasEndorsNum"-->
      <!--        :hasClaimNum="hasClaimNum"-->
      <!--        @update="handleUpdate"-->
      <!--        @nextStep="nextStep"-->
      <!--        @cancelReply="handleCancelReply"-->
      <!--        @save-draft="saveDraft"-->
      <!--        @reply-all="replyAll"-->
      <!--        @complete="replyComplete"-->
      <!--        @cancel="showReply = false"></reply-new-sme-refer>-->
    </section>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import InsuredVehicleForm from '@/views/components/insured-vehicle-form'
import PolicyHolder from '@/views/components/policy-holder-form'
import DriversBaseInfoForm from '@/views/components/drivers-base-info-form'
import DocumentForm from './document-form'
import ReplyRefer from './reply-refer'
import {saveReferCaseOrder} from '@/api/order'
import {getReferralExtra, getReferralReplyCase} from '@/api/refer'
import {mapActions, mapState} from 'vuex'
import HousemaidPolicyForm from '@/views/quoting/modules/housemaid/form/housemaid-policy-form'
// import DecorationPolicyForm from '@/views/quoting/modules/decoration/form/decoration-policy-form'
import EditDecorationPolicyForm from './modules/decoration/edit-decoration-policy-form'
import EditHomefirePolicyForm from './modules/homefire/edit-homefire-policy-form'
import EditTravelPolicyForm from './modules/travel/edit-travel-policy-form'
import EditWorkingPolicyForm from './modules/working/edit-working-policy-form'
import EditStudentPolicyForm from './modules/student/edit-student-policy-form'
import EditPersonalPolicyForm from './modules/personal/edit-personal-policy-form'
import EditFirePolicyForm from './modules/homefire/edit-fire-policy-form'
import EditDronePolicyForm from './modules/drone/edit-drone-policy-form'
import EditPetPolicyForm from './modules/pet/edit-pet-policy-form'
import quickQuote from '@/views/components/quick-quote'
import smeForm from '@/views/quoting/sme/component/sme-form'
import {renewOrderSave, renewReplyCase,saveRenewalTicketOrder} from '@/api/renewal'
import {addSMERenewal, saveSMEKyc} from '@/api/sme'
import replyNewSmeRefer from './sme/reply-new-sme-refer'
import UsePersonalData from '@/views/components/use-personal-data'
import TicketRemark from '@/views/tickets/components/ticket-remark'
import ReminderDetail from '@/views/renew/components/reminder-detail'
import smeKycForm from '@/views/sme/components/sme-kyc-form'
import {editSMETicket} from '@api/new_sme'
export default {
  name: 'EditReferCase',
  components: {
    ReminderDetail,
    InsuredVehicleForm,
    PolicyHolder,
    DriversBaseInfoForm,
    ReplyRefer,
    DocumentForm,
    HousemaidPolicyForm,
    // DecorationPolicyForm,
    EditDecorationPolicyForm,
    EditHomefirePolicyForm,
    EditFirePolicyForm,
    EditTravelPolicyForm,
    EditStudentPolicyForm,
    EditWorkingPolicyForm,
    EditPersonalPolicyForm,
    EditDronePolicyForm,
    quickQuote,
    UsePersonalData,
    TicketRemark,
    EditPetPolicyForm,
    smeKycForm
  },
  mixins: [MixinOptions, MixinRules],
  props: {
    editType: {
      type: Number,
      default: 0 // 0 - 正常 edit， 1 - reply, 2 - upgrade, 3 - renewal
    },
    checkRefer:{
      type: Number,
      default: 0 // 0 - 正常 edit， 1 - reply refer, 2 - 确认refer
    },
    form: {
      type: Object,
      default: () => ({})
    },
    relation: {
      type: Object,
      default: () => ({})
    },
    customerId: {
      type: Number,
      default: 0
    },
    isShowQuick: {
      type: Number,
      default: 0
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    fromQuote: {
      type: Boolean,
      default: false
    },
    fromEdit: {
      type: Boolean,
      default: false
    },
    hasEndorsNum: {
      type: Boolean,
      default: false
    },
    hasClaimNum: {
      type: Boolean,
      default: false
    },
    isFina: {
      type: Boolean,
      default: false
    },
    isRenewalTicket: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      policyOneDriver: false, // 投保人關聯第一名記名司機
      formDataLock: 0, // 表單鎖，防止外層修改數據覆蓋了組件裏的表單數據
      requireValid: false,
      showReply: false,
      formData: {
        class_id: 14,
        cust_typ: 1,
        pcy_cmnt_dt: '',
        trm_of_cvr: '',
        hp_ind: '',
        isrd_vl: '',
        mortgagor: '',
        already_owned_by_ind: '',
        mortgagor_other:'',
        updDefInfo: [],
        less_verify_save: 1, // 部分保存
        extra_benefits:[],
        benefits: [],
        no_claim_3_year:'',
        type_of_ins:'',
        is_eff_dt_delay:'',

        nmc_plil_limit_amt:0,
        plil_limit_amt:0,
        tppd_limit_amt:0,
        nmc_tppd_limit_amt:0,
        is_nmc_plil_limit_amt:'',
        is_nmc_tppd_limit_amt:'',
        limit_type:0,
        plil_limit_type:0,
      },
      resultParams: {},
      subForm: {
        'insured-vehicle-form': false,
        'policy-holder': false,
        'drivers-base-info-form': false
      },
      currentDriversData: [],
      extraData:[],
      extrabenefitsList:[],
      notShowList: [],
      renewOrderId: 0,
      continueData:{},
      check: true,
      personalData: {},
      renew_form: {},
      isSMEAdd:false,
      add_ticket_id:'',
      is_insured:false,
      is_extra:false,
    }
  },
  computed: {
    ...mapState('ticket', ['referData']),
    limitVaild(){
      let {limit_type,plil_limit_type} = this.formData||{}
      if(limit_type==1||plil_limit_type==1)
        return true
      return false
    },
    ticket_id(){
      let {ticket_id} = this.$route.query||{}
      return ticket_id
    },
    benefitList(){
      let {quote_coverage_list} =this.form||{}
      let {kyc_benefit=[]} = quote_coverage_list||{}
      let arr = []
      kyc_benefit.some(item=>{
        // if(item.is_selected==1)
        //   this.formData.benefits.push(item.id)
        if(item.is_show!==0){
          arr.push({name:item.name,id:item.id})
        }
      })
      return arr||[]
    },
    productId() {
      return this.form.product_id||11
    },
    classId() {
      return this.formData.class_id || 14
    },
    isHzmb(){
      return this.classId==15
    },
    orderId() {
      return this.productId>=80?this.form.order_id:this.formData.id
    },
    referId() {
      return this.formData.refer_id
    },
    localAllOptions() {
      if (this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`] || { mortgagor: [] }
      }
    },
    insuredItems(){
      if(this.isSME) return []
      // if(this.editType == 3){
      //   let arr = JSON.parse(JSON.stringify(this[`allOptions${this.formData.class_id == 14? '' : this.formData.class_id}`].benefits))
      //   return arr
      // }
      let {quote_coverage_list} = this.formData||{}
      let {kyc_benefit=[]} = quote_coverage_list||{}
      return kyc_benefit||[]
      // if(quote_coverage_list){
      //   // let {quote_coverage_list} = this.formData
      //   let {kyc_benefit=[]} = quote_coverage_list||{}
      //   return kyc_benefit||[]
      // }
      // return []
    },
    title() {
      const titleArray = [
        'Edit Refer Case Request',
        'Enter Client Information To Quote',
        'Enter Client Information To Quote',
        'Enter Renewal Policy Information'
      ]
      return titleArray[this.editType]
    },
    mortgagorOption() {
      // 拿status 為1的數據
      let { mortgagor=[] } = this.localAllOptions
      if(mortgagor.length) {
        mortgagor = mortgagor.filter(e=>e.status)
      }
      return mortgagor
    },
    isMortgagorOther(){
      let {mortgagor}=this.formData
      let list = this.mortgagorOption.filter(item=>{
        return item.id==mortgagor
      })
      return list.length>0&&list[0].is_other==1?true:false
    },
    // extrabenefitsList() {
    //   let benefits = this.localAllOptions.extra_benefits || []
    //   // benefits = benefits.filter(item=>item.is_enabled==1)
    //   if(this.isFina) return []
    //   return benefits||[]
    // },
    fileList(){
      let {file} = this.relation||{}
      return file||[]
    },
    marketing_data(){
      let {marketing_data={}} = this.referData||{}
      return this.productId >= 80? marketing_data : this.formData.marketing_data
    },
    isSME(){
      return this.productId >=80
    },
    isCAR(){
      return this.classId ==79
    },
    isMotorTrade(){
      return this.classId==13
    },
    isTPlate(){
      let {type_of_ins} = this.formData||{}
      return type_of_ins ==1
    },
    isKeepPreQuote(){
      let {stts} = this.form||{}
      return stts>=250
    },
    plill_limit_label(){
      let {plil_limit_amt}= this.formData||{}
      let {nmc_plil_opt=[]} = this.allOptions15
      let result = {}
      result = nmc_plil_opt.find(item=>item.condition===plil_limit_amt)||{}
      return result
    },
    limit_label(){
      let {tppd_limit_amt}= this.formData||{}
      let {nmc_tppd_opt=[]} = this.allOptions15
      let result = {}
      result = nmc_tppd_opt.find(item=>item.condition===tppd_limit_amt)||{}
      return result
    },
  },
  watch: {
    limitVaild:{
      immediate: true,
      handler(val){
        if(val){
          this.$nextTick(()=>{
            this.$refs.form.clearValidate(['limit_type','plil_limit_type'])
          })
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formDataLock += 1
        this.formData = Object.assign(this.formData, JSON.parse(JSON.stringify(val)))
        this.handlerExtraData()
        if(this.editType == 3){
          let {product_id} = val||{}
          if(product_id<80)
            this.renewOrderId = this.fromQuote || this.fromEdit? this.form.id : this.form.renew_order_id
          let renew_form = JSON.parse(JSON.stringify(this.renew_form))
          this.formData = Object.assign(this.formData,renew_form)
          if(this.isHzmb){
            let {tppd_limit_amt,plil_limit_amt,nmc_tppd_limit_amt,nmc_plil_limit_amt} = val||{}
            this.formData.limit_type = tppd_limit_amt>0?1:0
            this.formData.plil_limit_type = plil_limit_amt>0?1:0
            this.formData.is_nmc_tppd_limit_amt = nmc_tppd_limit_amt>0?1:0
            this.formData.is_nmc_plil_limit_amt = nmc_plil_limit_amt>0?1:0
          }
          // this.formData.tppd_limit_amt = tppd_limit_amt
          // this.formData.plil_limit_amt = plil_limit_amt
          // this.formData.nmc_tppd_limit_amt = nmc_tppd_limit_amt
          // this.formData.nmc_plil_limit_amt = nmc_plil_limit_amt
        }
        let {extra_benefits=[],benefits=[]} = this.formData||{}
        if(extra_benefits.length>0)this.is_extra = true
        if(benefits.length>0)this.is_insured = true
        // if(val.class_id==11)
        //   this.network().getReferralExtra()
      }
    },
    editType: {
      immediate: true,
      handler(val) {
        this.requireValid = val === 2 || val == 3? true: false
        if(val == 3){
          let {product_id} = val||{}
          if(product_id<80)
            this.renewOrderId = this.fromQuote || this.fromEdit? this.form.id : this.form.renew_order_id
          let renew_form = JSON.parse(JSON.stringify(this.renew_form))
          this.formData = Object.assign(this.formData,renew_form)
        }
      }
    },
    checkRefer:{
      immediate: true,
      handler(val) {
        // this.requireValid = val === 2? true: false
        if(val == 2){
          this.requireValid = true
        }
      }
    },
    'formData.trm_of_cvr':{
      immediate:true,
      handler(val){
        if(val){
          if(this.classId==11)
            this.network().getReferralExtra()
        }
      }
    }
  },
  methods: {
    ...mapActions('ticket', ['setTicketReferForm', 'setQuoteCase']),
    handleBenefits(){
      if(!this.is_insured)
        this.formData.benefits =[]
    },
    handleExtraBenefits(){
      if(!this.is_extra)
        this.formData.extra_benefits =[]
    },
    handleBackStep(){
      this.showReply = false
      if(this.$refs['ticket-remark']){
        this.$refs['ticket-remark'].handleUpdateRemark()
      }
    },
    changeInsurance(){
      this.handlerExtraData()
    },
    handlerExtraData(){
      let {class_id,model_id, nm_drvr_list, enough_age_ind,enough_exp_ind,rgtn_yr} = this.quoteForm||{}
      if(class_id==11)
      {
        let {trm_of_cvr = []} = this.filterData||{}
        this.updateExtraOptions({trm_of_cvr,class_id,model_id,rgtn_yr,nm_drvr_list,enough_age_ind,enough_exp_ind})
      }
    },
    handleModel(model_id){
      let {class_id, nm_drvr_list, enough_age_ind,enough_exp_ind,rgtn_yr} = this.quoteForm||{}
      this.formData.model_id = model_id
      if(class_id==11)
      {
        let {trm_of_cvr = []} = this.filterData||{}
        this.updateExtraOptions({trm_of_cvr,class_id,model_id,rgtn_yr,nm_drvr_list,enough_age_ind,enough_exp_ind})
      }
    },
    handleInd(params){
      Object.assign(this.formData,params)
      let obj = JSON.parse(JSON.stringify(this.formData))
      this.formData = obj
    },
    handleAlreadyOwned(val){
      this.formData.already_owned_by_ind = val
    },
    getTon(val){
      this.notShowList = []
      if(val != 5.5){
        this.notShowList = this.insuredItems.filter(item => {
          return item.group_name == 'crane_cvr' || item.group_name == 'tilgate_cvr'
        })
      }
    },
    getFieldData({ key, value }) {
      this.$set(this.formData, key, value)
    },
    // 記名司機同步
    handlerOpenDriver(data, list) {
      this.currentDriversData = data
    },
    handlerConfirmChangeInfo(result) {
      if(result) {
        this.resultParams.upd_def_addr = 1
      }
      if(this.editType === 0) {
        this.network().saveOrder(this.resultParams)
      }else if(this.editType == 3){
        this.checkTips(this.resultParams)
        this.network().renewOrderSave(this.resultParams)
      } else {
        // this.handlerNextResult(this.resultParams)
        this.network().saveReferCaseOrder(this.resultParams)
      }
    },
    handlerDriverPolicyFile(data) {
      this.$refs['document-form'].updatePolicyFile(data)
    },
    // 投保人資料關聯幾名司機
    handlerPolicyDriverInfo(data) {
      const id_type_pic = this.$refs['document-form'].getCardFileData()
      const result = {
        ...data,
        id_type_pic
      }
      this.$refs['drivers-base-info-form'].handlerPolicyDriverInfo(result)
    },
    handlerSave() {
      const productForm = {
        12: 'housemaid-policy-form',
        13: 'working-policy-form',
        14: 'travel-policy-form',
        15: 'decoration-policy-form',
        16: 'student-policy-form',
        17: 'homefire-policy-form',
        18: 'personal-policy-form',
        20: 'fire-policy-form',
        21: 'drone-policy-form',
        22: 'pet-policy-form',
        80: 'sme-form'
      }
      if(this.productId != 11) {
        this.$refs[productForm[this.productId]].submitForm({
          type: 'save'
        })

      }
      else {
        // 表單校驗
        if(!this.handler().validateForm()) {
          return
        }
        this.$refs.form.validate(async (valid, rules) => {
          if(valid) {
            // 獲取表單組件數據
            const params = await this.handler().getFormDataResult()
            console.log('getFormDataResult---',params)
            if(!params) return false
            const { updDefInfo } = params
            if(updDefInfo && updDefInfo.length > 0) {
              // if(params.isUpdatePolicyData === 1) {
              this.$refs['policy-holder'].openConfirmDialog()
            } else {
              this.network().saveOrder(params)
            }
          }
          else {
            this.scrollToValidDom(rules)
          }
        })
      }

    },
    checkTips(data){
      this.handleUpdate()
      if(this.hasClaimNum || this.hasEndorsNum){
        this.continueData = data
        this.check = false
        this.$emit('nextStep', 2)
      }
    },
    continueAndNext(){
      this.check = true
      this.network().renewOrderSave(this.continueData)
    },
    handlerNext() {
      if(this.isSME){
        this.$refs['sme-form'].submitForm()
        return
      }
      this.updateExtraOptions({
        class_id: this.classId,
        scene_insurer: 2
      })
      const productForm = {
        12: 'housemaid-policy-form',
        13: 'working-policy-form',
        14: 'travel-policy-form',
        15: 'decoration-policy-form',
        16: 'student-policy-form',
        17: 'homefire-policy-form',
        18: 'personal-policy-form',
        20: 'fire-policy-form',
        21: 'drone-policy-form',
        22: 'pet-policy-form',
      }
      // if(this.productId == 20 && this.editType != 2){
      //   this.$refs[productForm[this.productId]].getSubmitFormNoValid({
      //     type: 'next'
      //   })
      //   return
      // }
      if(this.productId != 11) {
        this.$refs[productForm[this.productId]].submitForm({
          type: 'next'
        })
        return
      }
      // 表單校驗
      if(!this.handler().validateForm()) {
        return
      }
      this.$refs.form.validate(async (valid, rules) => {
        if(valid) {
          // 獲取表單組件數據
          const params = await this.handler().getFormDataResult()
          if(!params) return false
          const { updDefInfo } = params
          if(updDefInfo && updDefInfo.length > 0&&!this.isFina) {
            // if(params.isUpdatePolicyData === 1) {
            this.$refs['policy-holder'].openConfirmDialog()
          } else {
            // this.handlerNextResult(params)
            if(this.editType == 3){
              this.checkTips(params)
              this.network().renewOrderSave(params)
            }else{
              this.network().saveReferCaseOrder(params)
            }
          }

        }
        else {
          this.scrollToValidDom(rules)
        }
      })
    },
    handlerNextResult(params) {
      this.setTicketReferForm(params)
      // 獲取公司回復報價
      if(this.editType == 3){
        this.network().renewReplyCase({
          order_id: this.renewOrderId
        })
      }else{
        this.network().getReferralReplyCase({
          refer_id: this.referId,
          // is_filter_rejected :
          // Complete Buyable 階段左側需要過濾掉 Rejected Case;
          is_filter_rejected: this.editType === 2? 1: 0
        })
      }
      this.showReply = true
    },
    handleCancelReply(){
      this.network().renewReplyCase({
        order_id: this.renewOrderId
      })
    },
    nextStep(step){
      this.$emit('nextStep', step)
    },
    handleUpdate(){
      this.$emit('update')
    },
    saveDraft() {
      this.showReply = false
      this.$emit('save-draft')
    },
    replyAll() {
      this.showReply = false
      this.$emit('reply-all')
    },
    replyComplete() {
      this.showReply = false
      this.$emit('reply-complete')
    },
    // 更新司機文件數據
    uploadDriversFile(data) {
      // const { index, type, name, id } = data
      this.$refs['document-form'].updateDriversFile(data)
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      this.formData = Object.assign(this.formData, data)
    },
    getHousemaidFormData(data, otherData = {}) {
      const { type } = otherData
      if(type == 'save') {
        this.network().saveOrder({
          ...data,
          order_id: this.orderId,
          customer_id: this.customerId
        })
      }
      else {
        // this.handlerNextResult(data)
        if(this.editType == 3){
          this.checkTips(data)
          this.network().renewOrderSave(data)
        }else{
          this.network().saveReferCaseOrder(data)
        }
      }
    },
    getSMEFormData(data, otherData = {}) {
      this.handlerSMEStep(data, otherData = {})
    },
    handlerSMEStep(data, otherData = {}){
      const { type } = otherData
      if(type == 'save') {
        this.network().saveSMEKyc(data,true)
      }
      else {
        if(this.editType == 3){
          this.checkTips(data)
          this.network().renewOrderSave(data)
        }else{
          // this.network().saveReferCaseOrder(data)
          this.network().saveSMEKyc(data)
        }
      }
    },
    handlerUploadCardFile(data) {
      if(this.policyOneDriver) {
        this.$refs['drivers-base-info-form'].updateOnePolicyFile(data)
      }
    },
    handlerDeleteCardFile() {
      if(this.policyOneDriver) {
        this.$refs['drivers-base-info-form'].deleteOnePolicyFile()
      }
    },
    getData(personalData){
      this.personalData = personalData
    },
    handler() {
      return {
        validateForm: () => {
          if(this.isMotorTrade){
            delete this.subForm['insured-vehicle-form']
            if(this.isTPlate)
              delete this.subForm['drivers-base-info-form']
          }
          Object.keys(this.subForm).some(key => {
            this.subForm[key] = false
            this.$refs[key].submitForm(key)
          })
          if (Object.values(this.subForm).some(item => item === false)) {
            return false
          }
          return true
        },
        getFormDataResult: async () => {
          // 獲取表單組件數據
          if(this.isMotorTrade){
            delete this.subForm['insured-vehicle-form']
            if(this.isTPlate)
              delete this.subForm['drivers-base-info-form']
          }
          Object.keys(this.subForm).some(key => {
            this.subForm[key] = false
            this.$refs[key].submitForm(key)
          })
          if (Object.values(this.subForm).some(item => item === false)) {
            return
          }
          let params = JSON.parse(JSON.stringify(this.formData))
          const filterDriverList = params.nm_drvr_list.filter(item => item.open)
          params.nm_drvr_list = filterDriverList
          params.no_of_nm_drvr = params.nm_drvr_list.length || 0
          params.order_id = this.orderId
          params.customer_id = this.customerId
          if(this.isTPlate)
            params.hldr_is_drvr_ind = 0
          const documentFile = await this.$refs['document-form'].submitForm()
          if(!documentFile) {
            return false
          }
          if(this.isHzmb&&this.editType==3){
            let {is_nmc_tppd_limit_amt,is_nmc_plil_limit_amt} = this.formData
            params.nmc_tppd_limit_amt = is_nmc_tppd_limit_amt?this.limit_label.id:0
            params.nmc_plil_limit_amt = is_nmc_plil_limit_amt?this.plill_limit_label.id:0
          }
          Object.assign(params, documentFile)
          this.resultParams = params
          return params
        },
        handlerSaveOrderParams: data => {
          // const data = this.formData
          let params = {
            class_id: '',
            // less_verify_save: 0,
            pcy_cmnt_dt: '',
            mortgagor: '',
            trm_of_cvr: 1,
            hp_ind: '',
            isrd_vl: '',
            rgtn_no: '',
            usage_ind: '',
            brand_id: '',
            rgtn_mdl: '',
            typ_of_bdy_id: '',
            rgtn_yr: '',
            engn_cpcty: '',
            no_of_seats: '',
            chasis_no: '',
            engn_no: '',
            car_modified_ind: '',
            car_camcorder_ind: '',
            business_purposes: [],
            ncd_pct: '',
            prev_insurer_nm: '',
            prev_rgtn_no: '',
            prev_pcy_no: '',
            isrd_lst_nm: '',
            isrd_fst_nm: '',
            isrd_title: '',
            isrd_dob: '',
            id_type: '',
            id_no: '',
            mobile_no: '',
            email: '',
            occ_id: '',
            isrd_com_nm: '',
            phone_no: '',
            bsns_nature_id: '',
            contact_nm: '',
            contact_occ_id: '',
            contact_phone: '',
            contact_mobile: '',
            hldr_is_drvr_ind: '',
            addr_room: '',
            addr_floor: '',
            addr_block: '',
            addr_building: '',
            addr_street: '',
            addr_district: '',
            addr_area: '',
            addr_region: '',
            cust_typ: '',
            nm_drvr_list: [],
            // 11
            model_id: '',
            tonnage: '',
            pcy_expry_date: ''
          }
          Object.keys(params).some(key => {
            params[key] = data[key]
          })
          params.no_of_nm_drvr = params.nm_drvr_list.length || 0
          params.order_id = this.orderId
          params.customer_id = this.customerId
          return params
        },
      }
    },
    network() {
      return {
        saveOrder: async params => {
          // const lastParams = this.handler().handlerSaveOrderParams(params)
          const { data } = await saveReferCaseOrder({
            ...params
          })
          this.$emit('save-success')
        },
        // 公司回復報價
        getReferralReplyCase: async params => {
          this.setQuoteCase([])
          const { data } = await getReferralReplyCase(params)
          this.setQuoteCase(data)
        },
        saveReferCaseOrder: async params => {
          this.$refs['use-personal-data'].handleSendData()
          params.marketing_data = this.personalData
          const { data } = await saveReferCaseOrder({
            ...params,
            less_verify_save: this.editType == 2? 0: 1,
          })
          this.handlerNextResult(params)
        },
        getReferralExtra: async (params) => {
          let {trm_of_cvr} = this.formData||{}
          const {data} = await getReferralExtra({
            class_id: 11,
            is_renew_discount:this.editType==3?1:0,
            trm_of_cvr
          })
          this.extrabenefitsList = data.map(item => ({
            id: item.id,
            name: item.name
          }))
        },

        // renew单save
        renewOrderSave: async params => {
          // 判断是否需要弹窗显示
          if(this.check){
            if(this.$refs['use-personal-data'])
            {
              this.$refs['use-personal-data'].handleSendData()
              params.marketing_data = this.personalData
            }
            let temp = JSON.parse(JSON.stringify(params))
            delete temp.less_verify_save
            let renew_data ={}
            if(this.isSME){
              let {code,coupon_code,referrer_id} = this.form||{}
              temp.coupon_code = coupon_code
              temp.code = code
              temp.referrer_id = referrer_id
              let {merchant_platform} = this.formData||{}
              let {contents_isrd,stocks_isrd,total_pl_isrd} = temp||{}
              // if(!contents_isrd||contents_isrd<=0)
              //   delete temp.contents_isrd
              // if(!stocks_isrd||stocks_isrd<=0)
              //   delete temp.stocks_isrd
              // if(!total_pl_isrd||total_pl_isrd<=0)
              // delete temp.total_pl_isrd
              if(this.fromEdit||this.isSMEAdd){
                let {ticket_id} = this.formData||{}
                renew_data = await editSMETicket({
                  ...temp,
                  ticket_id:this.isSMEAdd?this.add_ticket_id:ticket_id,
                })
              }
              else{
                renew_data = await addSMERenewal({
                  ...temp,
                  order_id: this.renewÏOrderId,
                  ticket_id:this.ticket_id
                })
                this.isSMEAdd = true
                let {ticket_id} = renew_data.data||{}
                this.add_ticket_id = ticket_id
              }
            }
            else if(this.isRenewalTicket&&this.ticket_id&&!this.isSME){
              renew_data = await saveRenewalTicketOrder({
                ...temp,
                order_id: this.renewOrderId,
                ticket_id:this.ticket_id
              })
            }
            else
            {
              renew_data = await renewOrderSave({
                ...temp,
                pre_order_id: this.fromQuote || this.fromEdit? params.pre_order_id : params.id,
                order_id: this.renewOrderId,
              })
            }
            let {data} = renew_data||{}
            this.renewOrderId = data.order_id
            let formRenewData = {...temp,renew_order_id:this.renewOrderId}
            let renew_form = JSON.parse(JSON.stringify(formRenewData))
            this.renew_form = renew_form
            this.formData = Object.assign(this.formData,renew_form)
            this.formDataLock += 1
            this.$nextTick(() => {
              this.handlerNextResult(params)
            })
          }
        },

        renewReplyCase: async params => {
          this.setQuoteCase([])
          const { data } = await renewReplyCase(params)
          this.setQuoteCase(data)
        },
        //sme
        saveSMEKyc: async (params,isSave=false) => {
          if(this.$refs['use-personal-data'])
            this.$refs['use-personal-data'].handleSendData()
          let {data} = await saveSMEKyc({
            order_id: this.orderId,
            ...params,
            customer_id: this.customerId,
            marketing_data: this.personalData
          },this.referData.class_id)
          let {quotation_number} = data
          if(isSave){
            this.$emit('save-success')
            return
          }
          this.showReply = true
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.from-quote{
  padding: 0;
  margin: 15px 88px;
}
.edit-container {
    position: relative;
    padding: 15px;
    .abs-top-right {
        top: 20px;
        right: 15px;
        .discard{
          color: #CB2431;
        }
    }
  .width-remark-content{
    margin-right: 25px;
    width: calc(100% - 290px);
  }
  .width-reminder-content{
    //margin-right: 25px;
    //width: calc(100% - 345px);
    flex: 1;
    .width-700{
      width: 100%!important;
    }
  }
    .form-container {
        padding-right: 200px;
        min-width: 900px;
        .form-item {
            // padding-bottom: 0;
            span:first-child {
                font-size: 16px;
            }
        }
    }
    .file-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        padding: 0 15px;
        height: 65px;
        border: 1px solid #dddfe7;
        border-radius: 4px;
        background: #fcfcfc;
        .file-info {
          color: #616266;
          font-size: 16px;
        }
      }
  .title-quick{
    color: #24292E;
    font-family: Inter;
    font-size: 20px;
    font-weight: 600;
  }
  .margin-top-ten{
    margin-top: 10px;
  }
  .extra_checkbox{
    ::v-deep .el-checkbox-group{
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
</style>
